import { Create } from '@fund/api-modules';
import { setUserInfoBeforeRequest } from '@fund/api-modules/dist/tools/setUserInfo';
import TransformResponse from './decorator/TransformResponse';
import fundDetail1Model from '../model/fund-detail1.model';
import fundDetail2Model from '../model/fund-detail2.model';
import highEndMergeModel from '../model/high-end-merge.model';

@setUserInfoBeforeRequest((res) => ({
  // baseURL: 'https://dataapineice.1234567.com.cn/gongce',
  baseURL: 'https://dgs.tiantianfunds.com',
  params: {
    uid: res.passportid,
    version: '9.9.9',
    product: 'EFund',
    plat: 'Web',
    deviceid: res.deviceid,
  },
  headers: {
    Validmark: res.deviceid,
  },
}))
@Create({
  // baseURL: getApiHostWithoutEnv('dgs'), // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  // baseURL: 'https://dataapineice.1234567.com.cn/gongce',
  baseURL: 'https://dgs.tiantianfunds.com',
  params: {
    deviceid: '1234567.py.service',
    version: '6.5.5',
    appVersion: '6.5.5',
    product: 'EFund',
    plat: 'Iphone',
  },
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
})
class FundDgs {
  @TransformResponse((res) => fundDetail1Model.objectWithKeyValues(res?.data))
  getDetailPage1(param) {
    return this.POST('/merge/m/api/jjxqy1_2', {
      ...param,
      indexfields: '_id,INDEXCODE,BKID,INDEXNAME,INDEXVALUA,NEWINDEXTEXCH,PEP100',
      fields:
        'BENCH,ESTDIFF,INDEXNAME,LINKZSB,INDEXCODE,NEWTEXCH,FTYPE,FCODE,BAGTYPE,RISKLEVEL,TTYPENAME,PTDT_FY,PTDT_TRY,PTDT_TWY,PTDT_Y,DWDT_FY,DWDT_TRY,DWDT_TWY,DWDT_Y,MBDT_FY,MBDT_TRY,MBDT_TWY,MBDT_Y,YDDT_FY,YDDT_TRY,YDDT_TWY,YDDT_Y,BFUNDTYPE,YMATCHCODEA,RLEVEL_SZ,RLEVEL_CX,ESTABDATE,JJGS,JJGSID,ENDNAV,FEGMRQ,SHORTNAME,TTYPE,TJDIN,FUNDEXCHG,LISTTEXCHMARK,FSRQ,ISSBDATE,ISSEDATE,FEATURE,DWJZ,LJJZ,MINRG,RZDF,PERIODNAME,SYL_1N,SYL_LN,SYL_Z,SOURCERATE,RATE,TSRQ,BTYPE,BUY,BENCHCODE,BENCH_CORR,TRKERROR,BENCHRATIO,NEWINDEXTEXCH,BESTDT_STRATEGY,BESTDT_Y,BESTDT_TWY,BESTDT_TRY,BESTDT_FY',
      fundUniqueInfo_fIELDS:
        'FCODE,STDDEV1,STDDEV_1NRANK,STDDEV_1NFSC,STDDEV3,STDDEV_3NRANK,STDDEV_3NFSC,STDDEV5,STDDEV_5NRANK,STDDEV_5NFSC,SHARP1,SHARP_1NRANK,SHARP_1NFSC,SHARP3,SHARP_3NRANK,SHARP_3NFSC,SHARP5,SHARP_5NRANK,SHARP_5NFSC,MAXRETRA1,MAXRETRA_1NRANK,MAXRETRA_1NFSC,MAXRETRA3,MAXRETRA_3NRANK,MAXRETRA_3NFSC,MAXRETRA5,MAXRETRA_5NRANK,MAXRETRA_5NFSC,TRKERROR1,TRKERROR_1NRANK,TRKERROR_1NFSC,TRKERROR3,TRKERROR_3NRANK,TRKERROR_3NFSC,TRKERROR5,TRKERROR_5NRANK,TRKERROR_5NFSC', // 特色数据
      fundUniqueInfo_fLFIELDS: 'FCODE,BUSINESSTYPE,BUSINESSTEXT,BUSINESSCODE,BUSINESSSUBTYPE,MARK', // 大数据榜单入口
      cfhFundFInfo_fields: 'INVESTMENTIDEAR,INVESTMENTIDEARIMG',
      ISRG: 0,
      relateThemeFields: 'FCODE,SEC_CODE,SEC_NAME,CORR_1Y,OL2TOP',
    });
  }

  @TransformResponse((res) => fundDetail2Model.objectWithKeyValues(res?.data))
  getDetailPage2(param) {
    return this.POST('/merge/m/api/jjxqy2', {
      ...param,
    });
  }

  // 高端理财聚合接口
  @TransformResponse((res) => highEndMergeModel.objectWithKeyValues(res?.data))
  getHighEndMergeData(fundCode) {
    return this.POST('/merge/m/api/premiumFinancing', {
      FCODES: fundCode,
      FundSameGDLCInfosPageIndex: 1,
      FundSameGDLCInfosPageSize: 30,
      FundSameGDLCInfosSortColumn: 'REALORDER',
      FundSameGDLCInfosSort: 'desc',
      FundIndexDiyFIELDS: 'W,M,Q,HY,Y,TWY,TRY,FY,SE,SY,INDEXNAME',
      FundSameGDLCInfosFIELDS:
        'FUNDSERISE,FUNDSERISENAME,SELLSTATE,SELLSTATE2,IPOENDDATE,Y,SE,PROFITANNUAL,CYCLE,RISKLEVEL,MININVEST,OPERATIONPERIOD,FUNDCODE,FUNDNAME,EXPIRESPECIALTYPE,SELLORDER,REALORDER',
      FundGDLCInfosFIELDS:
        'EXPIRESPECIALTYPE,FUNDCODE,FUNDNAME,C_PRODUCTNAME,C_SGRATE,SHRATEMARK,FUNDTYPE,FUNDTYPENAME,ISAUTOCONTINUE,FUNDCOMPANYNAME,FUNDMANAGER,PROFITANNUAL,SYI,MUI,NAV,JZRQ,HBJZRQ,MININVEST,OPERATIONPERIOD,RISKLEVEL,MARKETENDDATE,PEOPLELIMITSP,WHOLELIMIT,SGRATEMARK,MARKETBEGINDATE,APPURL,FUNDBUSINTYPE,SE,OPENRULE,DAYS,IS_QSSYPZ,DTZT,MINDT,PHOTOHTTP,PHOTO,REMARK,STABILSHDATE,HY,ANNUAL,MANAGER,M,SY,RATE,BENCHMARK,Q,CARD,MINAPPEND,W,Y,BUYREMIND,TWY,FY,TRY,FUNDCODEINRECORD,INCOMEDISTRIBUTION,ISBUYREMIND,LOSSLIMITNAV,MANAGEMENTINTRO,BENCHMARK,GSVALUEDATE,STAGEENDDATE,OVERCARRY,PEOPLELIMITSP,FINTYPE,FUNDSIGNSTATUS,ISMANANULSIGNED,IPOENDDATE,PERIOD,CLOSEDAYS,IPOBEGINDATE,NEXTBEGINDATE,REDEEMBEGINDATE,REDEEMENDDATE,MANAGEMENTFEE,TRUSTEEFEE,SALESFEE,PERFORMANCEFEE,SSBCFMDATA,RDMCFMDATA,DRAWCFMDATA,REMARK_URL,INVESTMENTMANAGERINTRO,SMANAGER,MNGSCALE,REGCAPITAL,FOUNDDATE,NBIGTYPE,NSMALLTYPE2,PROFITANUAL,MAXRETRAHY,MAXRETRAY,MAXRETRATWY,MAXRETRATRY,MAXRETRAFY,MAXRETRASY,MAXRETRASE,SHARPSY,SHARPSE,SHARPHY,SHARPY,SHARPTWY,SHARPTRY,SHARPFY,FUNDSERISE,ISOPTIMAL,OPTIMALREASON,OPTIMALREASON,ISOPTIMAL,SELLSTATE,ISORGPROMOT,SELLSTATE2,REDEMTYPE,REDEMSECTION,ACHIEVETYPE,ACHIEVESECTION,ACHIEVEEFFDATE,ACCRUALRATE,ISPVT,NVRENO_HY,NVRENO_Y,NVRENO_TWY,NVRENO_TRY,NVRENO_FY,NVRENO_SY,NVRENO_SE,NVRENO_HY_EDATE,NVRENO_Y_EDATE,NVRENO_TWY_EDATE,NVRENO_TRY_EDATE,NVRENO_FY_EDATE,NVRENO_SY_EDATE,NVRENO_SE_EDATE,M_3_YEAR,Q_3_YEAR,HY_3_YEAR,Y_3_YEAR,TWY_3_YEAR,PQ_3_YEAR,PHY_3_YEAR,PY_3_YEAR,PTWY_3_YEAR,MANAGERCODE,BRIGHTPOINT,DIRECTION,STRATEGY,ACHIEVEMENT,MANAGEABILITY,INTERPRETPIC,INTERPRETATION_TIME,CLOSEDATE,CALMAR_Y,CALMAR_TRY,CALMAR_FY',
      managerInfoFields: 'DEGREE,MGRNAME,HOLDDAYS,RESUME,YIELDSINCES,PATICTERM,HOLDDAYS,MGRID',
      gdlcConfigFields:
        'BUTTON,ILLUSTRATION,ENDTIME,ISBUTTON,LINKTYPE,LINKURL,MFCODE,REPORTDATE,REPORTTYPE,STARTTIME',
      // 阶段涨幅排名
      hisRankFields:
        'BUYSTATE,WRANK,WSC,MRANK,MSC,QRANK,QSC,HYRANK,HYSC,YRANK,YSC,TWYRANK,TWYSC,TRYRANK,TRYSC,FYRANK,FYSC,SYRANK,SYSC',
      // 风险评估特色数据排行
      fundIndictFields:
        'BUYSTATE,MAXRETRA_RANK_Y,MAXRETRA_RANK_TRY,MAXRETRA_RANK_FY,MAXRETRA_NUM_Y,MAXRETRA_NUM_TRY,MAXRETRA_NUM_FY,SHARP_RANK_Y,SHARP_RANK_TRY,SHARP_RANK_FY,SHARP_NUM_Y,SHARP_NUM_TRY,SHARP_NUM_FY,NVRENO_RANK_Y,NVRENO_RANK_TRY,NVRENO_RANK_FY,NVRENO_NUM_Y,NVRENO_NUM_TRY,NVRENO_NUM_FY,CALMAR_RANK_Y,CALMAR_RANK_TRY,CALMAR_RANK_FY,CALMAR_NUM_Y,CALMAR_NUM_TRY,CALMAR_NUM_FY',
    });
  }
}

const fundDgs = new FundDgs();

export default fundDgs;
